import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  EXERCISE_GAP_FILL_WITH_HINT,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_CONTENT,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTION,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS,
  ExerciseGapFillWithHintQuestionOptions,
} from './types';
import { ExerciseGapFillWithHintReadOnlyPlugin } from './ExerciseGapFillWithHintReadOnlyPlugin';

const GapFillWithHintMultipleChoiceOption = withDynamicBlogEditorPluginHydration({
  canInteract: true,
})(
  dynamicEditorComponent<any>(() =>
    import('./components/GapFillWithHintMultipleChoiceOption').then(
      (mod) => mod.GapFillWithHintMultipleChoiceOption
    )
  )
);
const ExerciseGapFill = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import('../GapFill/components/ExerciseGapFill').then((mod) => mod.ExerciseGapFill)
  )
);
const GapFillQuestion = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('../GapFill/components/GapFillQuestion').then((mod) => mod.GapFillQuestion)
  )
);
const GapFillWithHintQuestionContent = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('./components/GapFillWithHintQuestionContent').then(
      (mod) => mod.GapFillWithHintQuestionContent
    )
  )
);
const GapFillWithHintQuestionOptions = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('./components/GapFillWithHintQuestionOptions').then(
      (mod) => mod.GapFillWithHintQuestionOptions
    )
  )
);

export const ExerciseGapFillWithHintPlugin = (
  options?: ExerciseGapFillWithHintQuestionOptions
): SlatePlugin => {
  if (options?.isReadOnly) {
    return ExerciseGapFillWithHintReadOnlyPlugin(options);
  }

  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;

      switch (element.type) {
        case EXERCISE_GAP_FILL_WITH_HINT: {
          return <ExerciseGapFill {...renderProps} {...options} />;
        }
        case EXERCISE_GAP_FILL_WITH_HINT_QUESTION: {
          return <GapFillQuestion {...renderProps} {...options} />;
        }
        case EXERCISE_GAP_FILL_WITH_HINT_QUESTION_CONTENT: {
          return <GapFillWithHintQuestionContent {...renderProps} {...options} />;
        }
        case EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS: {
          return <GapFillWithHintQuestionOptions {...renderProps} {...options} />;
        }
        case EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTION: {
          return <GapFillWithHintMultipleChoiceOption {...renderProps} {...options} />;
        }
        default:
      }
      return null;
    },
  };
};
